import { z } from 'zod'
import { Currency } from '../../enums/currency.enum'

const timeRegex = /^([01]\d|2[0-3]):[0-5]\d$/

export const createRecurrentIncomeSchema = z
  .object({
    name: z.string().min(1).max(100),
    amount: z.number().nonnegative().optional(),
    currency: z.nativeEnum(Currency),
    dayOfMonth: z.number().int().min(1).max(31),
    creationTime: z.string().regex(timeRegex, 'Must be HH:mm').default('12:00'),
    accountId: z.string().guid(),
    categoryId: z.string().guid(),
    description: z.string().max(500).optional(),
    notifyDaysBefore: z.number().int().min(1).max(30).optional(),
    notifyTime: z.string().regex(timeRegex, 'Must be HH:mm').optional(),
    notifyMessage: z.string().max(500).optional(),
    endDate: z.string().datetime().optional(),
    active: z.boolean().optional().default(true),
  })
  .refine((data) => !data.notifyDaysBefore || data.notifyTime, {
    message: 'notifyTime is required when notifyDaysBefore is set',
    path: ['notifyTime'],
  })

export type CreateRecurrentIncomeDto = z.infer<typeof createRecurrentIncomeSchema>
